<ng-template #htmlContent><p [innerHTML]="errorMessage"></p></ng-template>
<div class="scan-icon-button" id="myBtn" (click)="tt.open()" 
    [ngbTooltip]="htmlContent"
    #tt="ngbTooltip" 
    [placement]="isPantherLakeRedesign ? 'bottom' : 'top'" 
    [tooltipClass]="isPantherLakeRedesign ? 'no-arrow-tooltip' : ''"
    container="body">
</div>